import React from "react";
import { useLocation } from "react-router-dom";
import styles from "./styles.module.scss";
import cx from "classnames";
import PropTypes from "prop-types";
import useAppContext from "../AppContext";
import routes from "../../routes";

function SiteWrapper({
  children,
  size = "large",
  contentWrapper = false,
  bottomPaddingLarge = false
}) {
  const location = useLocation();
  const { newQuiz } = useAppContext();

  return (
    <div
      className={cx(styles.main, styles[size], {
        [styles.bottomPadding]:
          contentWrapper &&
          !(
            newQuiz.isSequence ||
            ((newQuiz.isUni3 || newQuiz.isUni4) &&
              location.pathname === routes.createAccount)
          ),
        [styles.bottomPaddingLarge]:
          bottomPaddingLarge && contentWrapper && !newQuiz.isSequence
      })}
    >
      {children}
    </div>
  );
}

SiteWrapper.propTypes = {
  size: PropTypes.oneOf(["small", "large"])
};

export default SiteWrapper;
